// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3029c","right":"styles_right__12wJ_"};